import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { Translation } from 'react-i18next'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { HashLink } from 'react-router-hash-link'

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .use(HttpApi)
    .init({
        supportedLngs: ['EN', 'FR'],
        fallbackLng: 'FR',
        backend: {
            loadPath: '/assets/locales/{{lng}}/translation.json',
        },
        react: {
            useSuspense: true,
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i'],
        },
    })

class Header extends Component {
    constructor(props) {
        super(props)
    }

    handleLanguageChange(e) {
        const newLang = e.target.value
        window.location.href = '/' + newLang
    }

    render() {
        const { t } = this.props

        return (
            <div>
                <Navbar bg="light" expand="lg" fixed="top">
                    <Container>
                        <Navbar.Brand as={Link} to="/">
                            <img
                                src="/assets/img/logo-red-white.webp"
                                width="150px"
                                className="logo me-auto navbarStyle"
                                alt="ARGENT AUJOURD’HUI!"
                            />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto"></Nav>
                            <Nav.Link as={Link} to="/">
                                <Translation>
                                    {(t) => <span>{t('navbar_title1')}</span>}
                                </Translation>
                            </Nav.Link>
                            <Nav.Link as={HashLink} className="is-active" to="/#about">
                                <Translation>
                                    {(t) => <span>{t('navbar_title2')}</span>}
                                </Translation>
                            </Nav.Link>
                            <Nav.Link as={HashLink} to="/#faq">
                                <Translation>
                                    {(t) => <span>{t('navbar_title3')}</span>}
                                </Translation>
                            </Nav.Link>

                            <NavDropdown title="AVANTAGES">
                                <NavDropdown.Item
                                    as={Link}
                                    to="/avantages/pret-personnalise"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt personnalisé
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/avantages/pret-rapide"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt rapide
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/avantages/pret-sans-enquete-credit"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt sans enquête de crédit
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/avantages/pret-sans-refus"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt sans refus
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/avantages/pret-virement-immediat"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt virement immédiat
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title="BESOINS">
                                <NavDropdown.Item
                                    as={Link}
                                    to="/besoins/pret-sur-salaire-aucun-refus"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt sur salaire sans aucun refus
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/besoins/pret-urgent-rapide"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt urgent rapide
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title="MICRO PRÊTS">
                                <NavDropdown.Item
                                    as={Link}
                                    to="/micro-prets/100"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Micro prêt de 100$
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/micro-prets/200"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Micro prêt de 200$
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/micro-prets/300"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Micro prêt de 300$
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title="SITUATIONS">
                                <NavDropdown.Item
                                    as={Link}
                                    to="/situations/pret-mauvais-credit"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt mauvais crédit
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/situations/pret-sans-emploi"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Prêt sans emploi
                                </NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link>
                                <select
                                    className="form-select"
                                    value="FR"
                                    onChange={this.handleLanguageChange}
                                    style={{ width: 115 }}
                                >
                                    <option value="FR">Français</option>
                                    <option value="EN">English</option>
                                </select>
                            </Nav.Link>
                            <Link to="/new-lead" className="getstarted scrollto me-2">
                                <Translation>
                                    {(t) => <span>{t('navbar_button')}</span>}
                                </Translation>
                            </Link>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
        )
    }
}
export default Header
